import { Share } from "@capacitor/share";
import { Capacitor } from "@capacitor/core";

export const PUBLIC_POST_SHARE_HOST = "https://dietasocial.it";
export const POST_SHARE_DESCRIPTION_MAX_LENGTH = 140;

const stripHtml = (s) =>
  String(s || "")
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();

const truncateDescription = (
  value,
  maxLength = POST_SHARE_DESCRIPTION_MAX_LENGTH,
) => {
  const description = stripHtml(value);
  if (description.length <= maxLength) return description;

  const availableText = description.slice(0, maxLength - 1).trimEnd();
  const lastSpace = availableText.lastIndexOf(" ");
  const wordSafeText =
    lastSpace >= Math.floor(maxLength * 0.75)
      ? availableText.slice(0, lastSpace)
      : availableText;

  return `${wordSafeText.trimEnd()}…`;
};

export const buildPostShareUrl = (groupId, postId) =>
  `${PUBLIC_POST_SHARE_HOST}/gruppi/${groupId}/${postId}`;

export const createShareEventId = () => {
  if (globalThis?.crypto?.randomUUID) {
    return globalThis.crypto.randomUUID();
  }

  // RFC 4122 v4 fallback for older WebViews. It is used as an idempotency key,
  // not as a security token.
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (char) => {
    const random = Math.floor(Math.random() * 16);
    const value = char === "x" ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
};

export const buildShareTextParts = (postGroup) => {
  const title = stripHtml(postGroup?.post?.title) || "Guarda questo post";
  const description = truncateDescription(
    postGroup?.post?.description || postGroup?.post?.content,
  );
  return { title, description };
};

export const sharePost = async ({ postGroup }) => {
  if (!postGroup) return { shared: false, copied: false };
  const groupId = postGroup.group_id;
  const postId = postGroup.id;
  const shareUrl = buildPostShareUrl(groupId, postId);
  const { title, description } = buildShareTextParts(postGroup);
  const text = description ? `${title}\n\n${description}` : title;

  if (Capacitor.isNativePlatform()) {
    await Share.share({
      title,
      text,
      url: shareUrl,
      dialogTitle: "Condividi post",
    });
    return { shared: true, copied: false };
  }

  if (typeof navigator !== "undefined" && navigator.share) {
    await navigator.share({ title, text, url: shareUrl });
    return { shared: true, copied: false };
  }

  if (typeof navigator !== "undefined" && navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(shareUrl);
    return { shared: false, copied: true };
  }

  throw new Error("Condivisione non disponibile");
};

export const isShareCanceledError = (error) =>
  /cancel|abort/i.test(String(error?.message || error?.name || ""));
